import Cookies from 'js-cookie';
import qs from 'qs';
import { Config } from "./initSdk";
import { isMock } from "../jsSdk/utils";

type GetUserId = (code: string) => Promise<string>;

/**
 * 生成 OAuth 路径
 * @returns {string}
 */
const generateOAuthUrl = (config: Config) => {
  const [redirectUri] = window.location.href.split('#');
  const searchObj = {
    appid: config.corpId,
    redirect_uri: encodeURIComponent(redirectUri),
    response_type: 'code',
    scope: 'snsapi_base',
    agentid: config.agentId,
    state: 'STATE',
  }; 
  const search = Object.entries(searchObj)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
  return `https://open.weixin.qq.com/connect/oauth2/authorize?${search}#wechat_redirect`;
};

/**
 * 检查是否需要重定向
 */
const checkRedirect = async (config: Config, getUserId: GetUserId, mockUserId?: string) => {
  // 检查是否是 mock 模式
  if (isMock) {
    if (mockUserId) {
      Cookies.set('userId', mockUserId);
    }
    return;
  }

  // 检查 userId 和 code 参数
  const userId = Cookies.get('userId');
  // alert('userId1：'+userId)
  const unAuth = !userId || userId === 'undefined' || userId === 'null';
  const codeExist = window.location.search.includes('code');
  // 如果未认证且不存在 code 参数，则重定向到微信 OAuth
  if (unAuth && !codeExist) {
    const oauthUrl = generateOAuthUrl(config);
    // alert('Redirecting to:'+ oauthUrl);
    window.location.replace(oauthUrl);
    return;
  }

  // 如果未认证但已经有 code 参数，则通过 code 获取 userId
  if (unAuth) {
    const code = qs.parse(window.location.search.slice(1)).code as string;
    if (code) {
      const newUserId = await getUserId(code);
      // alert('newUserId1：'+newUserId)
      Cookies.set('userId', newUserId);
    }
  }
};

export default checkRedirect;